import api from './api';

// Thin wrappers around the marketplace API. Mirrors server/routes/marketplace.js
// and app/services/marketplace.js (same endpoints/shapes) for the web client.

export const getCategories = () => api.get('/marketplace/categories').then((r) => r.data);
export const getCategory = (slug) => api.get(`/marketplace/categories/${slug}`).then((r) => r.data);

export const getListings = (params) => api.get('/marketplace/listings', { params }).then((r) => r.data);
export const getListing = (id) => api.get(`/marketplace/listings/${id}`).then((r) => r.data);

export const createListing = (body) => api.post('/marketplace/listings', body).then((r) => r.data);
export const updateListing = (id, body) => api.put(`/marketplace/listings/${id}`, body).then((r) => r.data);
export const deleteListing = (id) => api.delete(`/marketplace/listings/${id}`).then((r) => r.data);

export const uploadListingImages = (id, formData) =>
  api.post(`/marketplace/listings/${id}/images`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }).then((r) => r.data);

export const deleteListingImage = (id, imageId) =>
  api.delete(`/marketplace/listings/${id}/images/${imageId}`).then((r) => r.data);

export const saveListing = (id) => api.post(`/marketplace/listings/${id}/save`).then((r) => r.data);
export const unsaveListing = (id) => api.delete(`/marketplace/listings/${id}/save`).then((r) => r.data);

export const getSaved = (params) => api.get('/marketplace/saved', { params }).then((r) => r.data);
export const getMyListings = (params) => api.get('/marketplace/mine', { params }).then((r) => r.data);

export const recordContact = (id) => api.post(`/marketplace/listings/${id}/contact`).then((r) => r.data);

// Current user's garage vehicles — powers "fits my car".
export const getGarageVehicles = (userId) =>
  api.get(`/garages/${userId}/vehicles`).then((r) => r.data);
